// extracted by mini-css-extract-plugin
export default {"fullPageSpinner":"MyBigSpinner_fullPageSpinner__6ydhO","spinnerInner":"MyBigSpinner_spinnerInner__hhfsF","spin":"MyBigSpinner_spin__oVGmU"};